<div
    class="relative inline-flex items-center justify-center"
    [style.width.px]="size"
    [style.height.px]="size"
    role="timer"
    [attr.aria-valuemin]="0"
    [attr.aria-valuemax]="totalMs"
    [attr.aria-valuenow]="remainingMs"
    [attr.aria-label]="formatRemaining() + ' remaining'"
>
    <svg
        class="block rotate-[-90deg]"
        [attr.width]="size"
        [attr.height]="size"
        [attr.viewBox]="'0 0 ' + size + ' ' + size"
    >
        <!-- background track -->
        <circle
            [attr.cx]="center"
            [attr.cy]="center"
            [attr.r]="radius"
            [class]="
                remainingMs === 0 ? 'stroke-error-600' : 'stroke-tertiary-100'
            "
            stroke-width="12"
            fill="none"
        ></circle>

        <!-- remaining ring (shrinks toward 0) -->
        <circle
            [attr.cx]="center"
            [attr.cy]="center"
            [attr.r]="radius"
            [class]="
                percentageRemaining > 0.5
                    ? 'stroke-success-500'
                    : percentageRemaining > 0.2
                      ? 'stroke-warn-400'
                      : 'stroke-error-600'
            "
            stroke-width="12"
            stroke-linecap="round"
            fill="none"
            [attr.stroke-dasharray]="circleStrokeDasharray"
            [attr.stroke-dashoffset]="circleStrokeDashOffset"
            style="transition: stroke-dashoffset 0.3s linear"
        ></circle>
    </svg>

    <!-- center label -->
    <div class="absolute text-center -rotate-0">
        <div class="text-xl font-medium text-tertiary-900 select-none -my-1">
            {{ formatRemaining() }}
        </div>
        <div class="text-sm text-tertiary-900 select-none">Remaining</div>
    </div>
</div>
